import { LOAD_TRUSTPILOT_SCRIPT } from './constants';

export const loadTrustPilotScript = shouldLoadTrustPilotScript => ({
  type: LOAD_TRUSTPILOT_SCRIPT,
  payload: shouldLoadTrustPilotScript
});
